var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canCreatePipeline)?_c('pipelines-ci-templates'):_c('pipelines-empty-state',{attrs:{"description":_vm.$options.i18n.noCiDescription}})
}
var staticRenderFns = []

export { render, staticRenderFns }